module.exports = __webpack_public_path__ + "static/and-f664ef3fda272200f3d95d279ec36c66.png";